function SalesNotification() {
  const sn_notification = document.querySelector('.sales-notification');
  const sn_data = document.querySelector('.sales-notification-data');
  const sn_close = sn_notification.querySelector('.sn_btn_close');
  
  setPromoFixedItem(sn_notification, sn_data);
  showPromoFixed(sn_notification, sn_notification.dataset.start);
  showPromoFixedNextMessage(sn_notification, sn_data, sn_close);

  sn_close.addEventListener('click', function() {
    sn_notification.classList.add('nonevent');
    sn_notification.style.opacity = 0;
  });
}

function showPromoFixedNextMessage(modal, data, close) {
  const nextmin = parseInt(modal.dataset.min);
  const nextmax = parseInt(modal.dataset.max);
  const i = getRndInteger(nextmin, nextmax);

  setTimeout(function() {
    close.dispatchEvent(new Event('click'));
    setTimeout(function() {
      setPromoFixedItem(modal, data);
      showPromoFixed(modal, 0);
      showPromoFixedNextMessage(modal, data, close);
    }, 100);
  }, i);
}

function getPromoFixedCustomProductIndex(sn_data) {
  const min = 0;
  const max = sn_data.children.length;
  return getRndInteger(min, max);
}

function setPromoFixedItem(modal, data) {
  const i = getPromoFixedCustomProductIndex(data);
  const productLink = modal.querySelector('.sn_product_image a');
  const productImg = productLink.querySelector('img');
  const productName = modal.querySelector('.sn_product_name');
  const randomMinutes = modal.querySelector('.random_minutes');
  const snLocation = modal.querySelector('.sn_location');
  
  const dataItem = data.children[i].dataset;
  
  productLink.href = dataItem.url;
  productImg.src = dataItem.image;
  productImg.alt = dataItem.alt;
  productName.href = dataItem.url;
  productName.textContent = dataItem.name;
  
  const nummin = parseInt(dataItem.min);
  const nummax = parseInt(dataItem.max);
  const num = getRndInteger(nummin, nummax);
  if (num) {
    randomMinutes.textContent = num;
  } else {
    randomMinutes.textContent = 10;
  }

  if (!dataItem.text) return false;
  snLocation.textContent = dataItem.text;
}

function showPromoFixed(parent, delay) {
  setTimeout(function() {
    parent.classList.remove('nonevent');
    parent.style.opacity = 1;
  }, delay);
}

function getRndInteger(min, max) {
  return Math.floor(Math.random() * (max - min)) + min;
}

setTimeout(SalesNotification, 300);
